import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Quickreply = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 2H2v20l4-4h9v-8h7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16h-2.2l1.7-4h-5v6h2v5z"
  }));
});
Quickreply.displayName = 'Quickreply';
export var QuickreplyDimensions = {
  height: 24,
  width: 24
};